// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"client_src_bootstrap_jsx":"3099cd11","node_modules_wkd_babel-preset-react-app_node_modules_babel_runtime_helpers_interopRequireDefa-8b58ea":"96d00a5e","node_modules_wkd_components_src_index_js":"3c4b3ca8","node_modules_wkd_api_src_index_scss":"96d00a5e"}[chunkId] + ".css";
};